const Unauthorized=()=> {
  return (
    <div className="h-screen flex items-center justify-center text-xl font-semibold text-red-600">
      🚫 Access Denied — You are not allowed to view this page.
    </div>
  );
}

export default Unauthorized;